import React from "react";
import PortalModal from "../../Portals";
import CloseIcon from "@mui/icons-material/Close";
import {
  ButtonAttend,
  CloseModal,
  ContentModal,
  TextModal,
  GeneralContainer,
} from "./NotificationResearchContainer.styled";
import Tooltip from "@material-ui/core/Tooltip";
import { IconButton } from "@material-ui/core";

const NotificationResearchContainer = ({ data, setOpen, fn }) => {
  return (
    <PortalModal>
      <GeneralContainer>
        <ContentModal>
          <CloseModal>
            <span
              style={{ marginLeft: "0.4em", color: "white", fontSize: "18px" }}
            >
              {"Alert"}
            </span>
            <Tooltip title="close">
              <IconButton onClick={() => setOpen(false)}>
                <CloseIcon style={{ color: "#fff" }} />
              </IconButton>
            </Tooltip>
          </CloseModal>
          <TextModal>
            <div
              dangerouslySetInnerHTML={{
                __html: data,
              }}
            ></div>
            <br />
          </TextModal>
          <div
            style={{
              display: "flex",
              margin: "auto",
              padding: "0em 1em 1em 0em",
              width: "100%",
              justifyContent: "flex-end",
            }}
          >
            <ButtonAttend onClick={() => fn(false)}>Attend</ButtonAttend>
          </div>
        </ContentModal>
      </GeneralContainer>
    </PortalModal>
  );
};

export default NotificationResearchContainer;
